//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MAX_UPLOAD_BYTES } from '@/utils/rfi-import-files'

// Client-side sheet chooser for the AI RFI import (LSO-717). Reads the workbook's
// sheet names in the browser — detecting sheets here (rather than a server round
// trip) keeps the import a single upload. Emits:
//   - confirm(sheetNames): proceed, sending only these sheets to the AI. An empty
//     array means "no choice needed" (≤1 sheet, or the file couldn't be parsed) —
//     the server reads the whole workbook, preserving the original behavior.
//   - cancel: the user backed out.
export default {
  name: 'RfiSheetSelect',
  props: {
    // The uploaded File (native browser File object).
    file: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      sheetNames: [],
      selected: []
    }
  },
  computed: {
    allSelected() {
      return this.sheetNames.length > 0 && this.selected.length === this.sheetNames.length
    }
  },
  mounted() {
    this.read()
  },
  methods: {
    async read() {
      this.loading = true
      try {
        // No file (caller bug / stale state): back out rather than silently
        // confirming an empty selection.
        if (!this.file) {
          this.$emit('cancel')
          return
        }
        // Never parse an oversized file on the main thread; the caller already refuses
        // these, so this only guards a direct use of the picker.
        if (this.file.size > MAX_UPLOAD_BYTES) {
          this.$emit('cancel')
          return
        }
        // Loaded on demand: the parser is large and only this step needs it, so it must
        // not ride along with every page that can open the import.
        const mod = await import('xlsx')
        const XLSX = mod.read ? mod : mod.default
        const buffer = await this.readArrayBuffer(this.file)
        const workbook = XLSX.read(new Uint8Array(buffer), { type: 'array', bookSheets: true })
        const names = (workbook.SheetNames || []).filter(Boolean)
        // Nothing to choose — let the server read the whole workbook as before.
        if (names.length <= 1) {
          this.$emit('confirm', [])
          return
        }
        this.sheetNames = names
        this.selected = names.slice()
      } catch (error) {
        // A client-side parse failure must not block the import — fall back to the
        // server reading every sheet.
        this.$emit('confirm', [])
      } finally {
        this.loading = false
      }
    },
    readArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = () => reject(reader.error || new Error('Could not read the file'))
        reader.readAsArrayBuffer(file)
      })
    },
    toggleAll() {
      this.selected = this.allSelected ? [] : this.sheetNames.slice()
    },
    confirm() {
      this.$emit('confirm', this.selected.slice())
    }
  }
}
